import apiMixin from "../../../mixins/apiMixin";
import userMixin from "../../../mixins/userMixin";

const UserManagement = {
    namespaced: true,
    state: {
        user_registration_progress_status: null,
        user_login_status: null,
        user_name: null,
        user_email: null,
        user_password: null,
        user_password_confirmation: null,
        userlogedOut: true,

        //plan
        user_plan_name: null,
        user_plan_status: null,
        user_plan_search_count: null

    },
    mutations: {
        setUserEmail: function (state, payload) {
            state.user_email = payload;
        },
        setUserPassword: function (state, payload) {
            state.user_password = payload;
        },
        setUserName: function (state, payload) {
            state.user_password_confirmation = payload;
        },
        setUserRegistrationProgressStatus: function (state, payload) {
            state.user_registration_progress_status = payload;
        },
        setUserLoginStatus: function (state, payload) {
            state.user_login_status = payload;
        },
        setuserlogedOut: function (state, payload) {
            state.userlogedOut = payload;
        },



    },
    actions: {
        registerUser: function (state, payload) {
            try {
                return apiMixin.methods.registerUser(payload).then(
                    response => {
                        if (!(response.status === 201)) {
                            /*registration Failed*/
                            state.commit('setUserRegistrationProgressStatus', false);
                        }
                        /*registration has been successfull*/
                        state.commit('setUserRegistrationProgressStatus', true);
                        /*After registration is successful,
                         Login the User
                         And Show User Activation Error Notification*/
                        //this.loginUser(payload);


                    },
                    error => {
                        console.error(error)
                    });
            } catch (e) {
                console.log(e);
            }

        },
        loginUser: function (state, payload) {
            return apiMixin.methods.loginUser(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }

                    /*Login Success*/
                    if (typeof response.data.result.user.first_name !== 'undefined') {
                        userMixin.methods.setUserName(response.data.result.user.first_name);
                        userMixin.methods.setUserEmail(response.data.result.user.email);
                        sessionStorage.setItem("user_id", response.data.result.user.id);
                    }
                    if (typeof response.data.result.user.first_name !== 'undefined') {
                        userMixin.methods.setUserAccessToken(response.data.result.access_token);
                    }
                    if (typeof response.data.result.user.first_name !== 'undefined') {
                        userMixin.methods.setUserLoginStatus(true);
                    }
                    //Plan//
                    if (typeof response.data.plan.status !== 'undefined') {
                        userMixin.methods.setUserPlanStatus(response.data.plan.status);
                    }
                    if (typeof response.data.plan.name !== 'undefined') {
                        userMixin.methods.setUserPlanName(response.data.plan.name);
                    }
                    if (typeof response.data.plan.search_count !== 'undefined') {
                        userMixin.methods.setUserPlanSearchCount(response.data.plan.search_count);
                    }
                    if (typeof response.data.plan.expiry_date !== 'undefined') {
                        userMixin.methods.setUserPlanExpiry_date(response.data.plan.expiry_date);
                    }


                    
                    state.commit('setuserlogedOut', false);
                    return true;

                });
        },
        logoutUser: function (state, payload) {

            apiMixin.methods.logoutUser(payload).then(
                response => {
                    if (response.data.result) {

                        var rememberMe_Email = localStorage.getItem('rememberMe_Email');
                        var rememberMe_Password = localStorage.getItem('rememberMe_Password');
                        var rememberMe_checkbox = localStorage.getItem('rememberMe_checkbox');
                        localStorage.clear();
                        localStorage.setItem('rememberMe_Email',rememberMe_Email);
                        localStorage.setItem('rememberMe_Password',rememberMe_Password);
                        localStorage.setItem('rememberMe_checkbox',rememberMe_checkbox);


                        localStorage.removeItem('khonsu_search_token');
                        localStorage.removeItem('now_dekonstrucktor_selected_types');
                        userMixin.methods.removesessionStorageItem('_khonsu_app_token');
                        userMixin.methods.removesessionStorageItem('_khonsu_user_login_status');
                        userMixin.methods.removesessionStorageItem('_khonsu_user_name');

                        userMixin.methods.removesessionStorageItem('_khonsu_user_plan_status');
                        userMixin.methods.removesessionStorageItem('_khonsu_user_plan_expiry_date');
                        userMixin.methods.removesessionStorageItem('_khonsu_user_plan_search_count');
                        sessionStorage.removeItem('user_id');
                        state.commit('setuserlogedOut', true);
                        window.location.href = '/login'
                        return true;
                    }

                });
        },
        forgetPassword: function (state, payload) {

            try {
                return apiMixin.methods.forgetPasswordUser(payload).then(
                    response => {
                        if (!response) {
                            return false;
                        }
                        if ((response.data.result.resetCode != null) && (typeof response.data.result.resetCode !== 'undefined')) {
                            localStorage.setItem('_khonsu_app_resetCode', response.data.result.resetCode);
                            localStorage.setItem('_khonsu_app_resetEmail', response.data.result.email);

                            return true;
                        }

                    }
                )
            } catch (e) {
                console.log(0);
            }

        },
        changeuserdetails: function (state, payload) {
            try {
                return apiMixin.methods.changeuserdetails(payload).then(
                    response => {
                        if (!response) {
                            return false;
                        }
                        if (response) {
                            return true;
                        }

                    }
                )
            } catch (e) {
                console.log(0);
            }
        },
        resetPassword: function (state, payload) {
            try {
                return apiMixin.methods.resetPasswordUser(payload).then(
                    response => {
                        if (!response) {
                            return false;
                        }
                        if ((response.data.result.id != null) && (typeof response.data.result.id !== 'undefined')) {
                            userMixin.methods.removesessionStorageItem('_khonsu_app_resetCode');
                            userMixin.methods.removesessionStorageItem('_khonsu_app_resetEmail');
                            return true;
                        }


                    }
                )
            } catch (e) {
                console.log(e);
            }
        },
        activateUser: function (state, payload) {
            try {
                return apiMixin.methods.activateUser(payload).then(
                    response => {
                        if (!response) {
                            return false;
                        }
                        if (response.status === 200) {
                            userMixin.methods.setUserActivationSuccessMsg(JSON.stringify(response.data));
                            return true;
                        }
                    }
                )
            } catch (e) {
                console.log(e);
            }
        }

    },
    getters: {},
}
export default UserManagement
